module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-25-808ba1d0b7b3900d028e0343b9072aa2.jpg";